export const CONTROLS = [
    {
        keys: ['W', 'A', 'S', 'D'],
        desc: 'Movement'
    },
    {
        keys: ['Shift'],
        desc: 'Sprint'
    },
    {
        keys: ['Space'],
        desc: 'Jump'
    },
    {
        keys: ['P'],
        desc: 'Punch'
    },
    {
        keys: ['C'],
        desc: 'Display Weapon Wheel'
    },
    {
        keys: ['T'],
        desc: 'Spawn gun'
    },
    {
        keys: ['Y'],
        desc: 'Aim'
    },
    {
        keys: ['K'],
        desc: 'Shoot'
    },
    {
        keys: ['F', 'or', 'G'],
        desc: 'Enter vehicle'
    },
    {
        keys: ['Shift', '+', 'R'],
        desc: 'Respawn'
    },
    {
        keys: ['Shift', '+', 'C'],
        desc: 'Free camera'
    }
];
